import React, { useRef } from 'react';
import { Label } from '@rebass/forms';
import { Flex, Box } from 'rebass';
import './cover.css';

function ZoomSlider({
  max,
  min,
  step,
  zoom = 0,
  width = '55px',
  onChange,
  showFullPercentage,
  showSign = '%',
  parentWidth,
  showActualValue = false,
  ...props
}) {
  const inputRef = useRef();

  const handleTouchMove = (event) => {
    const touch = event.touches[0];
    const rect = event.target.getBoundingClientRect();
    const x = touch.clientX - rect.left;
    const { width: rectWidth } = rect;
    const value = (x / rectWidth) * max;

    if (value <= max && value >= min) onChange({ target: { value } });
  };

  return (
    <Flex flexDirection="column" alignItems="center" marginRight={1} minWidth={180} width={parentWidth}>
      <Label htmlFor="zoom_control"
        color="#64748B" fontFamily="Poppins" fontSize="16px" letterSpacing="0.36px" lineHeight="150%"
        width={width} alignItems="center" fontWeight="500" mb={1}>
        {/* <Box
          as="input"
          type="input"
          value={
            showActualValue
              ? (+zoom).toFixed(1)
              : parseInt(zoom * (showFullPercentage ? 100 : 1), 10)
          }
          onChange={onChange}
          p={1}
          pr={0}
          sx={{
            border: 'none',
            bg: 'transparent',
            outline: 'none',
            fontSize: 1,
            textAlign: 'right',
          }}
        /> */}
        Zoom
      </Label>
      <input
        ref={inputRef}
        id="zoom_control"
        orient="vertical"
        type="range"
        value={zoom || 0}
        onChange={onChange}
        max={max}
        min={min}
        step={step}
        onTouchMove={handleTouchMove}
        {...props}
      />
    </Flex>
  );
}

export default ZoomSlider;
